/**
 * Estado de la membresía de un socio.
 *
 * Reporte de Kong House (17-ago): socios que llevan caducados desde 2024 no
 * mostraban ninguna señal, ni al buscarlos ni al darles entrada. El dato ya
 * viajaba en el perfil; solo faltaba mirarlo, y mirarlo IGUAL en todas las
 * pantallas — antes cada una se lo calculaba por su cuenta.
 *
 * OJO con dos cosas, aprendidas del propio dato:
 * - Sin fecha de caducidad NO se marca a nadie. Muchos socios migrados vienen
 *   sin ella, y llamarlos "caducados" sería inventarse una deuda.
 * - Se comparan FECHAS, no instantes: el día de la caducidad el socio todavía
 *   entra. Parseamos a mano el "YYYY-MM-DD" porque `new Date(iso)` lo trata
 *   como UTC y en España adelanta un día por la tarde.
 */
export function estaCaducado(socioOPerfil) {
  const perfil = socioOPerfil?.profile ?? socioOPerfil;
  const raw = perfil?.expiration_date;
  if (!raw) return false;
  const [y, m, d] = String(raw).split('T')[0].split('-').map(Number);
  if (!y || !m || !d) return false;
  const caduca = new Date(y, m - 1, d);
  const hoy = new Date();
  return caduca < new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
}

/** Días que faltan para caducar (negativo = ya caducó). null si no hay fecha. */
export function diasParaCaducar(socioOPerfil) {
  const perfil = socioOPerfil?.profile ?? socioOPerfil;
  const raw = perfil?.expiration_date;
  if (!raw) return null;
  const [y, m, d] = String(raw).split('T')[0].split('-').map(Number);
  if (!y || !m || !d) return null;
  const caduca = new Date(y, m - 1, d);
  const hoy = new Date();
  const cero = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  return Math.round((caduca - cero) / 86400000);
}
